// extracted by mini-css-extract-plugin
module.exports = {"container":"e_PA","widget":"e_QA","title":"e_RA","msrp":"e_SA","separator":"e_TA","textBadge":"e_UA"};